export const ua = navigator.userAgent.toLowerCase()

export const isWindows = /win32|wow32|win64|wow64/i.test(ua)

export const isIpad = /ipad/i.test(ua)

export const isAndroid = /android/i.test(ua)

export const isElectron = /electron/i.test(ua)

export const isMetis = /metislive/i.test(ua)

export const isMetisTeacher = /Metis\/Teacher/i.test(ua)

export const isClient = isElectron || (isMetis && isIpad)
